import { Icon } from '@/components/Icon';
import { useT } from '@/lib/useLang';

/**
 * Le « zéro risque » en quatre cartes : remboursé, compte intact, sans
 * engagement, une vraie personne au bout du fil. Même grille que Focus.
 */
export function RiskFree() {
  const t = useT();

  return (
    <section id="risk-free" className="nz-section">
      <div className="nz-eyebrow">{t.riskEyebrow}</div>
      <h2 className="nz-h2">{t.riskH2}</h2>
      <p className="nz-lead">{t.riskP}</p>

      <div className="nz-focus__grid">
        {t.riskItems.map((item) => (
          <div className="nz-focus__item" key={item.title}>
            <div className="nz-focus__mark">
              <Icon name={item.icon} className="nz-focus__icon" />
            </div>
            <div className="nz-focus__title">{item.title}</div>
            <div className="nz-focus__body">{item.body}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
